import { render, staticRenderFns } from "./DashboardSmartFeatures.vue?vue&type=template&id=57eb0685&scoped=true&"
import script from "./DashboardSmartFeatures.vue?vue&type=script&lang=js&"
export * from "./DashboardSmartFeatures.vue?vue&type=script&lang=js&"
import style0 from "./DashboardSmartFeatures.vue?vue&type=style&index=0&id=57eb0685&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57eb0685",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VAvatar,VCard,VCardText,VCardTitle,VChip})
